"use strict";

import React, { Component } from 'react';

import { BrowserRouter, Route, Link, Switch } from 'react-router-dom';

import logo from '../img/logo.png';
import face from '../img/face.png';

class Header extends Component {
    render() {
        return (
            <header className="header clearfix limite">
                <div className="divLogo">
                    <img src={logo} />
                </div>
                <div className="divFace">
                    <a href="http://www.facebook.com/facoppunoeste" target="_blank" >  <img src={face} /> </a>
                </div>
            </header>
        );
    }
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js